(function() {
  var STORAGE_KEY = 'tdWishlist.v1';
  var MAX_BADGE = 9;
  var MAX_ITEMS = 50;
  var PRUNE_INTERVAL_MS = 6 * 60 * 60 * 1000;
  var PRUNE_STAMP_KEY = 'tdWishlist.pruneAt.v1';
  var drawerController = null;
  var returnToWishlistAfterCartClose = false;
  var reopenCartAfterWishlistClose = false;
  var cartDrawerWasOpen = false;
  var wishlistDrawerWasOpen = false;
  var refreshPromise = null;
  var strings = (window.theme && theme.strings) ? theme.strings : {};
  var DOM_STRING_SELECTORS = {
    addToCart: '[data-td-wishlist-i18n-add-to-cart]',
    tdWishlistAdd: '[data-td-wishlist-i18n-add]',
    tdWishlistRemove: '[data-td-wishlist-i18n-remove]',
    tdWishlistRemoveShort: '[data-td-wishlist-i18n-remove-short]',
    tdWishlistViewItem: '[data-td-wishlist-i18n-view-item]',
    tdWishlistSavedCount: '[data-td-wishlist-i18n-saved-count]',
    tdWishlistOutOfStock: '[data-td-wishlist-i18n-out-of-stock]',
    tdWishlistOutOfStockNote: '[data-td-wishlist-i18n-out-of-stock-note]',
    tdLowStockOnlyLeft: '[data-td-wishlist-i18n-low-stock]',
    tdStockInStock: '[data-td-wishlist-i18n-stock-in-stock]',
    tdNoticeDemandAoDaiVariants: '[data-td-wishlist-i18n-demand-ao-dai-variants]',
    tdNoticeDemandDoLamVariants: '[data-td-wishlist-i18n-demand-do-lam-variants]',
    tdNoticeDemandFoodVariants: '[data-td-wishlist-i18n-demand-food-variants]',
    tdNoticeDemandGenericVariants: '[data-td-wishlist-i18n-demand-generic-variants]',
    tdNoticeSale: '[data-td-wishlist-i18n-sale]',
    tdNoticePriceDrop: '[data-td-wishlist-i18n-price-drop]',
    tdNoticeSaleVariants: '[data-td-wishlist-i18n-sale-variants]',
    tdNoticePriceDropVariants: '[data-td-wishlist-i18n-price-drop-variants]',
    tdNoticeNewArrival: '[data-td-wishlist-i18n-new-arrival]',
    tdNoticeReadyToShip: '[data-td-wishlist-i18n-ready-to-ship]'
  };

  function getI18nWrap() {
    return document.querySelector('[data-td-wishlist-i18n]');
  }

  function readDomString(key) {
    var selector = DOM_STRING_SELECTORS[key];
    if (!selector) return '';
    var wrap = getI18nWrap();
    var node = wrap ? wrap.querySelector(selector) : null;
    return node && node.textContent ? node.textContent.trim() : '';
  }

  function t(key, fallback) {
    var domValue = readDomString(key);
    if (domValue) return domValue;
    return (typeof strings[key] === 'string' && strings[key]) ? strings[key] : fallback;
  }

  function replaceCountToken(template, count) {
    var value = String(template == null ? '' : template);
    var token = String(count);

    value = value
      .replace(/\[count\]/gi, token)
      .replace(/\{\{\s*count\s*\}\}/gi, token)
      .replace(/__COUNT__/g, token);

    // Fallback for translated placeholders like [SỐ LƯỢNG]
    if (/\[[^\]]+\]/.test(value)) {
      value = value.replace(/\[[^\]]+\]/, token);
    }

    return value;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return { version: 2, items: {} };
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') throw new Error('bad');
      if (!parsed.items || typeof parsed.items !== 'object') parsed.items = {};

      var normalized = {};
      Object.keys(parsed.items).forEach(function(rawKey) {
        var item = parsed.items[rawKey];
        if (!item || typeof item !== 'object') return;
        var normalizedItem = Object.assign({}, item);
        var key = ensureItemKey(normalizedItem);
        if (!key) return;
        normalized[key] = normalizedItem;
      });

      removeRedundantProductKeys(normalized);
      return { version: 2, items: normalized };
    } catch (err) {
      return { version: 2, items: {} };
    }
  }

  function writeStore(store) {
    try {
      if (store && store.items && typeof store.items === 'object') {
        removeRedundantProductKeys(store.items);
      }
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (err) {}
  }

  function getItems() {
    var store = readStore();
    var items = Object.keys(store.items || {}).map(function(key) {
      var item = store.items[key] || {};
      return Object.assign({}, item, { key: item.key || key });
    });
    items.sort(function(a, b) { return (b.addedAt || 0) - (a.addedAt || 0); });
    return items;
  }

  function enforceMaxItems(store) {
    if (!store || !store.items || typeof store.items !== 'object') return store;

    var keys = Object.keys(store.items);
    if (keys.length <= MAX_ITEMS) return store;

    var ranked = keys.map(function(key) {
      return { key: key, addedAt: store.items[key] && store.items[key].addedAt ? store.items[key].addedAt : 0 };
    }).sort(function(a, b) {
      return b.addedAt - a.addedAt;
    });

    var nextItems = {};
    ranked.slice(0, MAX_ITEMS).forEach(function(entry) {
      nextItems[entry.key] = store.items[entry.key];
    });
    store.items = nextItems;
    return store;
  }

  function schedulePruneStamp() {
    try {
      window.localStorage.setItem(PRUNE_STAMP_KEY, String(Date.now()));
    } catch (err) {}
  }

  function shouldRunPrune() {
    try {
      var last = parseInt(window.localStorage.getItem(PRUNE_STAMP_KEY) || '0', 10) || 0;
      return !last || (Date.now() - last) >= PRUNE_INTERVAL_MS;
    } catch (err) {
      return true;
    }
  }

  function tdLocalizedPath(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (window.theme && theme.routes && theme.routes.home) || '/';
    root = String(root || '/');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function productJsonUrl(handle, forceFresh) {
    if (!handle) return '';
    var url = tdLocalizedPath('products/' + encodeURIComponent(handle) + '?view=td-wishlist-data');
    if (forceFresh) {
      url += '&_tdw=' + Date.now();
    }
    return url;
  }

  function buildVariantUrl(productUrl, variantId) {
    if (!productUrl) return '';
    if (!variantId) return productUrl;
    return productUrl + (productUrl.indexOf('?') === -1 ? '?variant=' : '&variant=') + encodeURIComponent(variantId);
  }

  function normalizeImageSrc(src) {
    if (!src) return '';
    if (typeof src === 'string') return src;
    if (src.src) return src.src;
    return '';
  }

  function stringifyTags(tags) {
    if (typeof tags === 'string') return tags;
    try {
      return JSON.stringify(Array.isArray(tags) ? tags : []);
    } catch (err) {
      return '[]';
    }
  }

  function buildItemKey(handle, variantId) {
    var cleanHandle = String(handle || '').trim();
    if (!cleanHandle) return '';
    var cleanVariantId = String(variantId || '').trim();
    return cleanHandle + '::' + (cleanVariantId || 'product');
  }

  function ensureItemKey(item) {
    if (!item) return '';
    var key = buildItemKey(item.handle, item.variantId);
    item.key = key;
    return key;
  }

  function getLegacyProductKey(handle) {
    return buildItemKey(handle, '');
  }

  function removeRedundantProductKeys(items) {
    if (!items || typeof items !== 'object') return items;

    var handlesWithVariantEntries = {};
    Object.keys(items).forEach(function(key) {
      var item = items[key];
      if (!item || !item.handle) return;
      if (String(item.variantId || '').trim()) {
        handlesWithVariantEntries[item.handle] = true;
      }
    });

    Object.keys(handlesWithVariantEntries).forEach(function(handle) {
      var legacyKey = getLegacyProductKey(handle);
      if (legacyKey && items[legacyKey]) {
        delete items[legacyKey];
      }
    });

    return items;
  }

  function getButtonItemKey(btn) {
    if (!btn) return '';
    return buildItemKey(btn.dataset.handle || '', btn.dataset.variantId || '');
  }

  function getTrackedStockQuantity(variant) {
    if (!variant || !variant.inventory_management) return 0;

    var policy = String(variant.inventory_policy || '').toLowerCase();
    var quantity = parseInt(variant.inventory_quantity, 10);

    if (policy !== 'deny' || !Number.isFinite(quantity)) return 0;
    return quantity > 0 ? quantity : 0;
  }

  function getTagText(tags) {
    if (Array.isArray(tags)) return tags.join('|').toLowerCase();
    var value = String(tags || '');
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.join('|').toLowerCase();
    } catch (err) {}
    return value.toLowerCase();
  }

  function getDiscountPercent(price, compareAtPrice) {
    var current = parseInt(price, 10) || 0;
    var compare = parseInt(compareAtPrice, 10) || 0;
    if (compare <= current || compare <= 0) return 0;
    return Math.max(1, Math.round(((compare - current) * 100) / compare));
  }

  function getStableNoticeVariant(item) {
    var productId = parseInt(item && item.productId, 10);
    if (Number.isFinite(productId)) return Math.abs(productId) % 6;

    var source = String((item && (item.handle || item.title)) || '');
    var hash = 0;
    for (var i = 0; i < source.length; i += 1) {
      hash = ((hash << 5) - hash + source.charCodeAt(i)) | 0;
    }
    return Math.abs(hash) % 6;
  }

  function pickNoticeVariant(template, index) {
    var options = String(template || '').split('||').map(function(value) {
      return value.trim();
    }).filter(Boolean);
    if (!options.length) return '';
    return options[index % options.length] || options[0];
  }

  function getDemandNotice(item, type) {
    var index = getStableNoticeVariant(item);
    var levels = ['demand-lilac', 'demand-rose', 'demand-blue', 'demand-coral', 'demand-teal', 'demand-plum'];
    var key = 'tdNoticeDemandGenericVariants';
    var fallback = 'Available to order||Popular pick • Shop now||Easy choice • Order today||Ready to order • Choose yours||Customer favorite • Shop now||Fresh pick • Choose yours';

    if (type === 'ao-dai') {
      key = 'tdNoticeDemandAoDaiVariants';
      fallback = 'Popular • Hold size||Elegant pick • Choose size||Trending style • Pick size||Special style • Order now||Customer favorite • Pick size||Beautiful choice • Choose yours';
    } else if (type === 'do-lam') {
      key = 'tdNoticeDemandDoLamVariants';
      fallback = 'Popular • Order now||Peaceful style • Shop now||Classic pick • Order today||Comfort pick • Choose yours||Serene favorite • Order now||Everyday comfort • Shop now';
    } else if (type === 'food') {
      key = 'tdNoticeDemandFoodVariants';
      fallback = 'Popular snack • Order now||Tasty pick • Grab yours||Snack time • Choose yours||Flavor pick • Shop now||Customer favorite • Add one||Treat yourself • Order now';
    }

    return {
      kind: 'demand',
      level: levels[index],
      variant: index,
      text: pickNoticeVariant(t(key, fallback), index)
    };
  }

  function getItemNotice(item) {
    if (!item) return null;

    var suffix = String(item.templateSuffix || '').toLowerCase();
    var tags = getTagText(item.tags);
    var policy = String(item.inventoryPolicy || '').toLowerCase();
    var quantity = parseInt(item.lowStockQuantity || '0', 10) || 0;
    var isAvailable = item.available !== false;
    var isFood = suffix.indexOf('food') !== -1 || tags.indexOf('food') !== -1 || tags.indexOf('snack') !== -1;
    var isAoDai = suffix.indexOf('ao-dai') !== -1 || tags.indexOf('ao dai') !== -1 || tags.indexOf('áo dài') !== -1;
    var isDoLam = suffix.indexOf('do-lam') !== -1 || tags.indexOf('do lam') !== -1 || tags.indexOf('đồ lam') !== -1;
    var isSpecialOrder = suffix.indexOf('preorder') !== -1 || tags.indexOf('_label_pre') !== -1 || policy === 'continue';
    var discountPercent = getDiscountPercent(item.price, item.compareAtPrice);

    // Sale always wins whenever compare-at price is higher than current price.
    if (discountPercent > 0) {
      var saleIndex = getStableNoticeVariant(item);
      var priceDrop = tags.indexOf('_label_pricedrop') !== -1 || tags.indexOf('_label_price-drop') !== -1 || tags.indexOf('_label_price_drop') !== -1;
      var saleTemplate = priceDrop
        ? t('tdNoticePriceDropVariants', 'Price drop • [count]% OFF||Just reduced • Save [count]%||Lower price • [count]% OFF||New markdown • Save [count]%||Better price • [count]% OFF||Fresh deal • Save [count]%')
        : t('tdNoticeSaleVariants', 'On sale • [count]% OFF||Save [count]% today||Special price • [count]% OFF||Deal price • Save [count]%||Marked down • [count]% OFF||Sale pick • Save [count]%');
      return {
        kind: 'sale',
        level: 'sale',
        count: discountPercent,
        variant: saleIndex,
        text: replaceCountToken(pickNoticeVariant(saleTemplate, saleIndex), discountPercent)
      };
    }

    if (isSpecialOrder) {
      if (isAoDai) return getDemandNotice(item, 'ao-dai');
      if (isDoLam) return getDemandNotice(item, 'do-lam');
      if (isFood) return getDemandNotice(item, 'food');
      return getDemandNotice(item, 'generic');
    }

    if (!isAvailable) return null;

    if (quantity > 0 && quantity <= 2) {
      return { kind: 'stock', level: 'red', count: quantity, text: replaceCountToken(t('tdLowStockOnlyLeft', 'Only [count] left'), quantity) };
    }
    if (quantity >= 3 && quantity <= 4) {
      return { kind: 'stock', level: 'yellow', count: quantity, text: replaceCountToken(t('tdLowStockOnlyLeft', 'Only [count] left'), quantity) };
    }

    if (tags.indexOf('_label_new') !== -1) {
      return { kind: 'new', level: 'new', text: t('tdNoticeNewArrival', 'New arrival') };
    }

    if (quantity >= 5 && quantity <= 9) {
      return { kind: 'stock', level: 'green', count: quantity, text: replaceCountToken(t('tdStockInStock', '[count] in stock'), quantity) };
    }
    if (quantity >= 10) {
      return { kind: 'stock', level: 'green', text: t('tdNoticeReadyToShip', 'Ready to ship') };
    }

    return null;
  }

  function refreshItemFromProductJson(item, product) {
    if (!item || !product || !product.handle) return null;

    var productUrl = product.url || tdLocalizedPath('products/' + product.handle);
    var next = Object.assign({}, item, {
      handle: product.handle,
      productId: product.id || item.productId || '',
      title: product.title || item.title || '',
      productUrl: productUrl,
      tags: stringifyTags(product.tags),
      templateSuffix: product.template_suffix || ''
    });

    var selectedVariant = null;
    if (item.variantId && Array.isArray(product.variants)) {
      selectedVariant = product.variants.find(function(variant) {
        return String(variant.id) === String(item.variantId);
      }) || null;
      if (!selectedVariant) return null;
    }

    if (selectedVariant) {
      next.variantId = String(selectedVariant.id);
      next.variantTitle = selectedVariant.title && selectedVariant.title !== 'Default Title' ? selectedVariant.title : '';
      next.available = !!selectedVariant.available;
      next.price = typeof selectedVariant.price === 'number' ? selectedVariant.price : (item.price || '');
      next.compareAtPrice = typeof selectedVariant.compare_at_price === 'number' ? selectedVariant.compare_at_price : '';
      next.inventoryManagement = selectedVariant.inventory_management || '';
      next.inventoryPolicy = selectedVariant.inventory_policy || '';
      next.lowStockQuantity = getTrackedStockQuantity(selectedVariant);
      next.url = buildVariantUrl(productUrl, next.variantId);

      var variantImage = selectedVariant.featured_image || selectedVariant.image || null;
      next.image = normalizeImageSrc(variantImage) || normalizeImageSrc(product.featured_image) || item.image || '';
      return next;
    }

    next.variantId = '';
    next.variantTitle = '';
    next.inventoryManagement = '';
    next.inventoryPolicy = '';
    next.lowStockQuantity = 0;
    next.available = Array.isArray(product.variants) ? product.variants.some(function(variant) { return !!variant.available; }) : !!item.available;
    next.url = productUrl;
    next.image = normalizeImageSrc(product.featured_image) || item.image || '';
    return next;
  }

  function pruneUnavailableItems(options) {
    if (!window.fetch) return Promise.resolve(false);
    options = options || {};

    var currentStore = readStore();
    var itemKeys = Object.keys(currentStore.items || {});
    if (!itemKeys.length) {
      schedulePruneStamp();
      return Promise.resolve(false);
    }

    var handles = [];
    var seenHandles = {};
    itemKeys.forEach(function(itemKey) {
      var entry = currentStore.items[itemKey];
      var handle = entry && entry.handle ? String(entry.handle) : '';
      if (!handle || seenHandles[handle]) return;
      seenHandles[handle] = true;
      handles.push(handle);
    });

    return Promise.all(handles.map(function(handle) {
      return fetch(productJsonUrl(handle, !!options.forceFresh), { credentials: 'same-origin', cache: options.forceFresh ? 'no-store' : 'default' })
        .then(function(res) {
          if (!res.ok) throw new Error('missing');
          return res.json();
        })
        .then(function(product) {
          return { handle: handle, product: product };
        })
        .catch(function() {
          return { handle: handle, product: null };
        });
    })).then(function(results) {
      var store = readStore();
      var changed = false;
      var productByHandle = {};
      results.forEach(function(result) {
        productByHandle[result.handle] = result.product;
      });

      Object.keys(store.items || {}).forEach(function(itemKey) {
        var existing = store.items[itemKey];
        if (!existing) return;
        var product = productByHandle[existing.handle || ''];

        if (!product) {
          delete store.items[itemKey];
          changed = true;
          return;
        }

        var refreshed = refreshItemFromProductJson(existing, product);
        if (!refreshed) {
          delete store.items[itemKey];
          changed = true;
          return;
        }

        var refreshedKey = ensureItemKey(refreshed);
        if (!refreshedKey) {
          delete store.items[itemKey];
          changed = true;
          return;
        }

        if (itemKey !== refreshedKey) {
          delete store.items[itemKey];
          store.items[refreshedKey] = refreshed;
          changed = true;
          return;
        }

        if (JSON.stringify(existing) !== JSON.stringify(refreshed)) {
          store.items[itemKey] = refreshed;
          changed = true;
        }
      });

      enforceMaxItems(store);
      writeStore(store);
      schedulePruneStamp();
      if (changed) emitUpdate();
      return changed;
    }).catch(function() {
      return false;
    });
  }

  function queuePruneIfNeeded() {
    if (!shouldRunPrune()) return;
    var runner = function() { pruneUnavailableItems(); };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(runner, { timeout: 1500 });
    } else {
      window.setTimeout(runner, 700);
    }
  }
  function refreshWishlistAvailabilityNow() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = pruneUnavailableItems({ forceFresh: true }).finally(function() {
      refreshPromise = null;
    });
    return refreshPromise;
  }


  function findSavedKeyForItem(item) {
    if (!item || !item.handle) return '';

    var exactKey = buildItemKey(item.handle, item.variantId || '');
    var legacyKey = getLegacyProductKey(item.handle);
    var store = readStore();
    if (!store.items || typeof store.items !== 'object') return '';

    if (exactKey && store.items[exactKey]) return exactKey;
    if (legacyKey && store.items[legacyKey]) return legacyKey;
    return '';
  }

  function maybeUpgradeLegacyItem(item) {
    if (!item || !item.handle || !item.variantId) return false;

    var exactKey = buildItemKey(item.handle, item.variantId);
    var legacyKey = getLegacyProductKey(item.handle);
    if (!exactKey || !legacyKey || exactKey === legacyKey) return false;

    var store = readStore();
    if (!store.items || typeof store.items !== 'object') return false;
    if (!store.items[legacyKey]) return false;

    var legacyItem = store.items[legacyKey];
    var upgraded = Object.assign({}, legacyItem, item, {
      addedAt: legacyItem && legacyItem.addedAt ? legacyItem.addedAt : (item.addedAt || Date.now())
    });
    ensureItemKey(upgraded);

    delete store.items[legacyKey];
    store.items[exactKey] = upgraded;
    writeStore(store);
    emitUpdate();
    return true;
  }

  function saveItem(item) {
    if (!item || !item.handle) return;
    var key = ensureItemKey(item);
    if (!key) return;
    var store = readStore();
    var nextItem = Object.assign({}, item, { key: key });

    if (item.variantId) {
      var legacyKey = getLegacyProductKey(item.handle);
      if (legacyKey && store.items && store.items[legacyKey]) {
        var legacyItem = store.items[legacyKey];
        if (legacyItem && legacyItem.addedAt && !nextItem.addedAt) {
          nextItem.addedAt = legacyItem.addedAt;
        }
        delete store.items[legacyKey];
      }
    }

    store.items[key] = nextItem;
    enforceMaxItems(store);
    writeStore(store);
    emitUpdate();
  }

  function isElementVisible(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  }

  function getRectCenter(el) {
    var rect = el.getBoundingClientRect();
    return {
      x: rect.left + (rect.width / 2),
      y: rect.top + (rect.height / 2)
    };
  }

  function removeItem(itemKey) {
    if (!itemKey) return;
    var store = readStore();
    if (store.items && store.items[itemKey]) {
      delete store.items[itemKey];
      writeStore(store);
      emitUpdate();
    }
  }

  function emitUpdate() {
    var items = getItems();
    document.dispatchEvent(new CustomEvent('td:wishlist:updated', {
      detail: { count: items.length, items: items }
    }));
  }

  function countLabel(count) {
    return replaceCountToken(t('tdWishlistSavedCount', '[count] saved items'), count);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
      }
    } catch (err) {}
    return '';
  }

  function findSelectedVariantIdInForm(scope) {
    var root = scope || document;
    var input = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input || !input.value) input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function collectTileItem(btn) {
    var card = btn.closest('.grid__item.grid-product, .grid-product, [data-product-handle]');
    if (!card) return null;

    var activeDot = card.querySelector('[data-td-variantdot].is-active') || card.querySelector('[data-td-variantdot]');
    var link = card.querySelector('.grid-product__link');
    var img = card.querySelector('.grid-product__image-mask img');
    var title = card.querySelector('.grid-product__title');
    var smartLabel = card.querySelector('[data-td-smart-label], [data-td-ps-smart-label]');

    var data = {
      handle: card.getAttribute('data-product-handle') || btn.dataset.handle || '',
      productId: parseInt(card.getAttribute('data-product-id') || btn.dataset.productId || '0', 10) || '',
      variantId: (card.getAttribute('data-td-selected-variant-id') || (activeDot && activeDot.getAttribute('data-variant-id')) || btn.dataset.variantId || ''),
      url: card.getAttribute('data-td-selected-variant-url') || (activeDot && activeDot.getAttribute('data-href')) || (link && link.getAttribute('href')) || btn.dataset.url || '',
      productUrl: (link && link.getAttribute('href')) || btn.dataset.productUrl || '',
      title: (title && title.textContent ? title.textContent.trim() : btn.dataset.title || ''),
      variantTitle: card.getAttribute('data-td-selected-variant-title') || (activeDot && activeDot.getAttribute('aria-label')) || btn.dataset.variantTitle || '',
      image: (img && (img.currentSrc || img.src)) || (activeDot && activeDot.getAttribute('data-img320')) || btn.dataset.image || '',
      price: parseInt(card.getAttribute('data-td-selected-variant-price') || btn.dataset.price || '0', 10) || '',
      compareAtPrice: parseInt(card.getAttribute('data-td-selected-variant-compare-at') || btn.dataset.compareAt || '0', 10) || '',
      available: card.getAttribute('data-td-selected-variant-available') ? (card.getAttribute('data-td-selected-variant-available') !== 'false') : (activeDot ? activeDot.getAttribute('data-soldout') !== '1' : btn.dataset.available !== 'false'),
      tags: (smartLabel && smartLabel.getAttribute('data-tags')) || btn.dataset.tags || '[]',
      addedAt: Date.now(),
      source: 'tile'
    };

    if (!data.productUrl) data.productUrl = data.url;
    if (data.variantTitle === 'Default Title') data.variantTitle = '';
    if (data.variantId && data.url && data.url.indexOf('variant=') === -1 && data.url.indexOf('/products/') !== -1 && data.url.indexOf('?') === -1) {
      data.url = data.url + '?variant=' + encodeURIComponent(data.variantId);
    }

    ensureItemKey(data);
    return data;
  }

  function collectDatasetItem(btn) {
    var item = {
      handle: btn.dataset.handle || '',
      productId: parseInt(btn.dataset.productId || '0', 10) || '',
      variantId: btn.dataset.variantId || '',
      url: btn.dataset.url || '',
      productUrl: btn.dataset.productUrl || btn.dataset.url || '',
      title: btn.dataset.title || '',
      variantTitle: btn.dataset.variantTitle || '',
      image: btn.dataset.image || '',
      price: parseInt(btn.dataset.price || '0', 10) || '',
      compareAtPrice: parseInt(btn.dataset.compareAt || '0', 10) || '',
      available: btn.dataset.available !== 'false',
      tags: btn.dataset.tags || '[]',
      addedAt: Date.now(),
      source: btn.dataset.tdWishlistSource || 'product'
    };

    if (item.variantTitle === 'Default Title') item.variantTitle = '';
    ensureItemKey(item);
    return item;
  }

  function collectItem(btn) {
    if (!btn) return null;
    var source = btn.dataset.tdWishlistSource || '';
    if (source === 'tile') return collectTileItem(btn);
    return collectDatasetItem(btn);
  }

  function badgeText(count) {
    return count > MAX_BADGE ? (MAX_BADGE + '+') : String(count);
  }

  function updateHeaderCount() {
    var count = getItems().length;
    document.querySelectorAll('[data-td-wishlist-count]').forEach(function(node) {
      node.textContent = badgeText(count);
      node.classList.toggle('is-visible', count > 0);
    });
    document.querySelectorAll('.td-wishlist-header').forEach(function(node) {
      node.classList.toggle('is-active', count > 0);
    });
  }

  function updateButtonState(btn) {
    if (!btn) return;
    var currentItem = collectItem(btn);
    if (currentItem && currentItem.variantId) {
      maybeUpgradeLegacyItem(currentItem);
    }
    var itemKey = currentItem ? findSavedKeyForItem(currentItem) : getButtonItemKey(btn);
    var active = !!itemKey;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');

    var labelNode = btn.querySelector('[data-td-wishlist-label]');
    var text = active ? t('tdWishlistRemove', 'Remove from Wishlist') : t('tdWishlistAdd', 'Add to Wishlist');
    if (labelNode) labelNode.textContent = text;
    btn.setAttribute('aria-label', text);
    btn.setAttribute('title', text);
  }

  function refreshButtons() {
    document.querySelectorAll('[data-td-wishlist-toggle]').forEach(updateButtonState);
    updateHeaderCount();
  }

  function closeCartDrawerIfOpen() {
    var cart = document.getElementById('CartDrawer');
    if (cart && cart.classList.contains('drawer--is-open')) {
      document.dispatchEvent(new CustomEvent('cart:close'));
    }
  }

  function closeWishlistDrawerIfOpen() {
    if (drawerController && drawerController.isOpen()) {
      drawerController.close();
    }
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function updateDatasetForProductButtons(variant) {
    document.querySelectorAll('[data-td-wishlist-context="product"]').forEach(function(btn) {
      if (!variant) {
        var currentVariantId = findSelectedVariantIdInForm(document);
        if (currentVariantId) {
          btn.dataset.variantId = currentVariantId;
        } else {
          btn.dataset.variantId = '';
          btn.dataset.variantTitle = '';
          btn.dataset.url = btn.dataset.productUrl || btn.dataset.url || '';
        }
        return;
      }

      btn.dataset.variantId = variant.id ? String(variant.id) : (btn.dataset.variantId || '');
      btn.dataset.variantTitle = variant.title || '';
      btn.dataset.available = variant.available ? 'true' : 'false';
      btn.dataset.price = typeof variant.price === 'number' ? String(variant.price) : (btn.dataset.price || '');
      btn.dataset.compareAt = typeof variant.compare_at_price === 'number' ? String(variant.compare_at_price) : '';
      if (variant.url) btn.dataset.url = variant.url;
      if (variant.featured_image && variant.featured_image.src) btn.dataset.image = variant.featured_image.src;
    });
  }

  function createHeartIconMarkup() {
    return '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="element-icon element-icon-heart element-icon--line" viewBox="0 0 64 64" width="20" height="20"><path d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44" fill="none" stroke="currentColor"></path></svg>';
  }

  function findWishlistTarget() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.js-drawer-open-wishlist'));
    for (var i = 0; i < buttons.length; i++) {
      if (isElementVisible(buttons[i])) return buttons[i];
    }
    return null;
  }

  function pulseWishlistTarget() {
    var target = findWishlistTarget();
    if (!target) return;
    target.classList.remove('td-wishlist-target-pulse');
    requestAnimationFrame(function() {
      target.classList.add('td-wishlist-target-pulse');
      window.setTimeout(function() {
        target.classList.remove('td-wishlist-target-pulse');
      }, 560);
    });
  }

  function animateToWishlist(sourceBtn) {
    if (!sourceBtn) return;
    var target = findWishlistTarget();
    if (!target) {
      pulseWishlistTarget();
      return;
    }

    var sourceEl = sourceBtn.querySelector('.element-icon, .icon, svg') || sourceBtn;
    var start = getRectCenter(sourceEl);
    var end = getRectCenter(target);
    if (!start || !end) return;

    var fly = document.createElement('div');
    fly.className = 'td-wishlist-fly';
    fly.innerHTML = createHeartIconMarkup();
    fly.style.setProperty('--td-wishlist-start-x', start.x + 'px');
    fly.style.setProperty('--td-wishlist-start-y', start.y + 'px');
    fly.style.setProperty('--td-wishlist-end-x', end.x + 'px');
    fly.style.setProperty('--td-wishlist-end-y', end.y + 'px');
    document.body.appendChild(fly);

    requestAnimationFrame(function() {
      fly.classList.add('is-flying');
    });

    window.setTimeout(function() {
      if (fly && fly.parentNode) fly.parentNode.removeChild(fly);
      pulseWishlistTarget();
    }, 1900);
  }

  function findCartTarget() {
    return document.querySelector('.js-drawer-open-cart .cart-link') ||
      document.querySelector('.js-drawer-open-cart');
  }

  function animateToCart(sourceEl, imgSrc) {
    if (!sourceEl || !imgSrc) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = findCartTarget();
    if (!target) return;

    var start = getRectCenter(sourceEl);
    var end = getRectCenter(target);
    if (!start || !end) return;

    var bubble = document.createElement('div');
    bubble.className = 'td-fly-to-cart';
    bubble.style.backgroundImage = 'url("' + String(imgSrc).replace(/"/g, '\"') + '")';
    bubble.style.left = start.x + 'px';
    bubble.style.top = start.y + 'px';
    bubble.style.transition = 'left 720ms cubic-bezier(0.2, 0.9, 0.2, 1), top 720ms cubic-bezier(0.2, 0.9, 0.2, 1), transform 620ms cubic-bezier(0.2, 0.9, 0.2, 1), opacity 480ms ease';
    document.body.appendChild(bubble);

    requestAnimationFrame(function() {
      bubble.classList.add('td-fly-to-cart--go');
      bubble.style.left = end.x + 'px';
      bubble.style.top = end.y + 'px';
    });

    var cleanup = function() {
      if (bubble && bubble.parentNode) bubble.parentNode.removeChild(bubble);
    };
    bubble.addEventListener('transitionend', cleanup, { once: true });
    window.setTimeout(cleanup, 900);
  }


  function renderDrawer() {
    if (!drawerController) return;
    drawerController.render();
  }

  function DrawerController() {
    this.root = document.getElementById('WishlistDrawer');
    if (!this.root || !window.theme || !theme.Drawers) return;

    this.drawer = new theme.Drawers('WishlistDrawer', 'wishlist');
    this.itemsContainer = this.root.querySelector('[data-td-wishlist-items]');
    this.emptyState = this.root.querySelector('[data-td-wishlist-empty]');
    this.footer = this.root.querySelector('[data-td-wishlist-footer]');
    this.countLabel = this.root.querySelector('[data-td-wishlist-count-label]');
    this.bind();
  }

  DrawerController.prototype.isOpen = function() {
    return !!(this.root && this.root.classList.contains('drawer--is-open'));
  };

  DrawerController.prototype.open = function(trigger) {
    if (!this.drawer) return;
    this.render();
    this.drawer.open(null, trigger || null);

    var self = this;
    if (this.root) this.root.classList.add('is-refreshing');
    refreshWishlistAvailabilityNow().then(function() {
      self.render();
    }).catch(function() {
      self.render();
    }).finally(function() {
      if (self.root) self.root.classList.remove('is-refreshing');
    });
  };

  DrawerController.prototype.close = function() {
    if (!this.drawer) return;
    this.drawer.close();
  };

  DrawerController.prototype.bind = function() {
    var self = this;

    document.addEventListener('wishlist:open', function(evt) {
      self.open(evt && evt.detail && evt.detail.trigger ? evt.detail.trigger : null);
    });
    document.addEventListener('wishlist:close', function() {
      self.close();
    });
    document.addEventListener('td:wishlist:updated', function() {
      self.render();
    });

    document.addEventListener('click', function(evt) {
      var removeBtn = evt.target.closest('[data-td-wishlist-remove]');
      if (removeBtn) {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        var itemKey = removeBtn.getAttribute('data-td-wishlist-remove') || '';
        window.setTimeout(function() {
          removeItem(itemKey);
          if (self.isOpen()) self.render();
        }, 0);
        return;
      }

      var cartMoveBtn = evt.target.closest('[data-td-cart-move-wishlist]');
      if (cartMoveBtn) {
        evt.preventDefault();
        evt.stopPropagation();
        moveCartItemToWishlist(cartMoveBtn);
        return;
      }

      var addCartBtn = evt.target.closest('[data-td-wishlist-add-cart]');
      if (addCartBtn) {
        evt.preventDefault();
        if (addCartBtn.disabled) return;
        self.addToCart(addCartBtn);
      }
    });
  };

  DrawerController.prototype.addToCart = function(btn) {
    var variantId = btn.getAttribute('data-td-wishlist-add-cart');
    var productUrl = btn.getAttribute('data-product-url') || '';
    var itemKey = btn.getAttribute('data-item-key') || '';
    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    btn.disabled = true;

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(res) {
      if (!res.ok) throw new Error('cart add failed');
      return res.json();
    }).then(function(payload) {
      var itemRoot = btn.closest('.td-wishlist-item');
      var flySource = null;
      var flyImage = '';

      if (itemRoot) {
        flySource = itemRoot.querySelector('.td-wishlist-item__image img') ||
          itemRoot.querySelector('.td-wishlist-item__image') ||
          btn;
        if (!flyImage) {
          var imgNode = itemRoot.querySelector('.td-wishlist-item__image img');
          if (imgNode) {
            flyImage = imgNode.getAttribute('src') || imgNode.getAttribute('data-src') || '';
          }
        }
      }

      if (!flySource) flySource = btn;
      if (!flyImage) flyImage = btn.getAttribute('data-image') || '';
      animateToCart(flySource, flyImage);

      if (itemKey) removeItem(itemKey);
      returnToWishlistAfterCartClose = true;
      reopenCartAfterWishlistClose = false;
      document.dispatchEvent(new CustomEvent('wishlist:close'));
      window.setTimeout(function() {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: payload }));
        openCartDrawer();
      }, 60);
    }).catch(function() {
      returnToWishlistAfterCartClose = false;
      if (productUrl) {
        window.location.href = productUrl;
      }
    }).finally(function() {
      btn.disabled = false;
    });
  };


  function collectCartWishlistItem(btn) {
    if (!btn) return null;
    var handle = btn.getAttribute('data-handle') || '';
    if (!handle) return null;

    return {
      handle: handle,
      productId: parseInt(btn.getAttribute('data-product-id') || '0', 10) || '',
      variantId: String(btn.getAttribute('data-variant-id') || ''),
      variantTitle: btn.getAttribute('data-variant-title') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      price: parseInt(btn.getAttribute('data-price') || '0', 10) || 0,
      compareAtPrice: parseInt(btn.getAttribute('data-compare-at') || '0', 10) || 0,
      available: String(btn.getAttribute('data-available') || '').toLowerCase() !== 'false',
      url: btn.getAttribute('data-url') || btn.getAttribute('data-product-url') || '',
      productUrl: btn.getAttribute('data-product-url') || btn.getAttribute('data-url') || '',
      tags: btn.getAttribute('data-tags') || '[]',
      addedAt: Date.now()
    };
  }

  function moveCartItemToWishlist(btn) {
    if (!btn || btn.disabled) return;
    var key = btn.getAttribute('data-key') || '';
    var item = collectCartWishlistItem(btn);
    if (!key || !item || !item.handle || !window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') return;

    btn.disabled = true;
    reopenCartAfterWishlistClose = false;

    theme.cart.changeItem(key, 0).then(function(cart) {
      var parsedCart = null;
      try { parsedCart = JSON.parse(cart); } catch (err) {}

      saveItem(item);
      animateToWishlist(btn);

      document.dispatchEvent(new CustomEvent('cart:build'));
      if (parsedCart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: parsedCart }
        }));
      }

      reopenCartAfterWishlistClose = true;
      closeCartDrawerIfOpen();
      window.setTimeout(function() {
        document.dispatchEvent(new CustomEvent('wishlist:open'));
      }, 120);
    }).catch(function() {
      reopenCartAfterWishlistClose = false;
      btn.disabled = false;
    }).finally(function() {
      window.setTimeout(function() {
        btn.disabled = false;
      }, 180);
    });
  }

  DrawerController.prototype.render = function() {
    if (!this.itemsContainer || !this.emptyState || !this.footer) return;

    var items = getItems();
    var hasItems = items.length > 0;
    this.emptyState.hidden = hasItems;
    this.itemsContainer.hidden = !hasItems;
    this.footer.hidden = !hasItems;

    if (!hasItems) {
      this.itemsContainer.innerHTML = '';
      if (this.countLabel) this.countLabel.textContent = '';
      return;
    }

    if (this.countLabel) this.countLabel.textContent = countLabel(items.length);

    this.itemsContainer.innerHTML = items.map(function(item) {
      var title = escapeHtml(item.title || '');
      var variantTitle = item.variantTitle && item.variantTitle !== 'Default Title'
        ? '<div class="td-wishlist-item__variant">' + escapeHtml(item.variantTitle) + '</div>'
        : '';
      var currentPrice = item.price ? '<span class="td-wishlist-item__price-current">' + formatMoney(item.price) + '</span>' : '';
      var smartLabel = "<div class=\"td-smart-label td-wishlist-item__smart-label\" data-td-smart-label data-tags='" + escapeHtml(item.tags || '[]') + "' hidden></div>";
      var comparePrice = item.compareAtPrice && item.compareAtPrice > item.price
        ? '<span class="td-wishlist-item__price-compare">' + formatMoney(item.compareAtPrice) + '</span>'
        : '';
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + title + '" loading="lazy">'
        : '';
      var itemNotice = getItemNotice(item);
      var itemNoticeHtml = itemNotice
        ? '<div class="td-low-stock-note td-low-stock-note--' + escapeHtml(itemNotice.level || '') + (itemNotice.kind === 'demand' ? ' td-low-stock-note--demand' : '') + '" data-td-item-notice data-notice-kind="' + escapeHtml(itemNotice.kind || '') + '"' + (itemNotice.count ? ' data-notice-count="' + escapeHtml(itemNotice.count) + '"' : '') + '>' + escapeHtml(itemNotice.text || '') + '</div>'
        : '';
      var isUnavailable = item.available === false;
      var statusHtml = isUnavailable
        ? '<div class="td-wishlist-item__status td-wishlist-item__status--unavailable">' + escapeHtml(t('tdWishlistOutOfStock', 'Out of stock')) + '</div>'
        : '';
      var noteHtml = isUnavailable
        ? '<div class="td-wishlist-item__note">' + escapeHtml(t('tdWishlistOutOfStockNote', 'Currently out of stock. Please wait for availability.')) + '</div>'
        : '';
      var cartAction = (item.variantId && item.available)
        ? '<button type="button" class="td-wishlist-item__cart" data-td-wishlist-add-cart="' + escapeHtml(item.variantId) + '" data-item-key="' + escapeHtml(item.key || '') + '" data-product-url="' + escapeHtml(item.productUrl || item.url || '') + '">' + escapeHtml(t('addToCart', 'Add to Cart')) + '</button>'
        : '<a class="td-wishlist-item__cart td-wishlist-item__cart--secondary" href="' + escapeHtml(item.productUrl || item.url || '') + '">' + escapeHtml(t('tdWishlistViewItem', 'View item')) + '</a>';

      return '' +
        '<div class="td-wishlist-item" data-item-key="' + escapeHtml(item.key || '') + '" data-handle="' + escapeHtml(item.handle) + '">' +
          '<div class="td-wishlist-item__media">' +
            '<a class="td-wishlist-item__image" href="' + escapeHtml(item.url || item.productUrl || '#') + '">' + image + '</a>' +
            itemNoticeHtml +
          '</div>' +
          '<div class="td-wishlist-item__content">' +
            '<a class="td-wishlist-item__title" href="' + escapeHtml(item.url || item.productUrl || '#') + '">' + title + '</a>' +
            smartLabel +
            variantTitle +
            statusHtml +
            '<div class="td-wishlist-item__price">' + currentPrice + comparePrice + '</div>' +
            noteHtml +
            '<div class="td-wishlist-item__actions">' +
              cartAction +
              '<button type="button" class="td-wishlist-item__remove" data-td-wishlist-remove="' + escapeHtml(item.key || '') + '">' + createHeartIconMarkup() + '<span>' + escapeHtml(t('tdWishlistRemoveShort', 'Remove')) + '</span></button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    if (window.TDSmartLabel && typeof window.TDSmartLabel.refresh === 'function') {
      window.TDSmartLabel.refresh(this.itemsContainer);
    }
  };

  function bindI18nRefresh() {
    var wrap = getI18nWrap();
    if (!wrap || typeof MutationObserver === 'undefined') return;

    var rerenderTimer = null;
    var observer = new MutationObserver(function() {
      window.clearTimeout(rerenderTimer);
      rerenderTimer = window.setTimeout(function() {
        renderDrawer();
        refreshButtons();
      }, 60);
    });

    observer.observe(wrap, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function bindOpenConflictHandling() {
    document.addEventListener('click', function(evt) {
      var wishOpen = evt.target.closest('.js-drawer-open-wishlist');
      if (wishOpen) {
        closeCartDrawerIfOpen();
        renderDrawer();
        return;
      }

      var cartOpen = evt.target.closest('.js-drawer-open-cart');
      if (cartOpen) {
        var fromWishlistDrawer = !!(cartOpen.closest && cartOpen.closest('#WishlistDrawer'));
        reopenCartAfterWishlistClose = false;
        returnToWishlistAfterCartClose = fromWishlistDrawer;
        closeWishlistDrawerIfOpen();
      }
    }, true);
  }

  function bindButtons() {
    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('[data-td-wishlist-toggle]');
      if (!btn) return;

      evt.preventDefault();
      evt.stopPropagation();

      var proceed = function(){
        var item = collectItem(btn);
        var itemKey = item ? findSavedKeyForItem(item) : getButtonItemKey(btn);
        var fallbackKey = item && item.key ? item.key : getButtonItemKey(btn);
        if (!itemKey && !fallbackKey) return;

        if (itemKey) {
          removeItem(itemKey);
        } else {
          animateToWishlist(btn);
          if (item && item.handle) saveItem(item);
        }

        updateButtonState(btn);
        refreshButtons();
        requestAnimationFrame(function() {
          updateButtonState(btn);
          refreshButtons();
        });
      };

      var card = btn.closest('.grid__item.grid-product, .grid-product, [data-product-handle]');
      var firstPassItem = collectItem(btn);
      var firstPassKey = firstPassItem ? findSavedKeyForItem(firstPassItem) : getButtonItemKey(btn);
      var activeDot = card ? card.querySelector('[data-td-variantdot].is-active') : null;
      if (activeDot && (activeDot.getAttribute('data-soldout') === '1' || activeDot.classList.contains('is-soldout'))) {
        proceed();
        return;
      }
      if (!firstPassKey && btn.dataset.tdWishlistSource === 'tile' && card && window.TDVariantPrompt && typeof window.TDVariantPrompt.resolve === 'function') {
        window.TDVariantPrompt.resolve(card, { action: 'wishlist', triggerEl: btn }).then(function(result){
          if (!result || result.status !== 'resolved') return;
          proceed();
        });
        return;
      }

      proceed();
    }, true);
  }




  function observeCartDrawerForReturn() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || !window.MutationObserver) return;

    cartDrawerWasOpen = cartDrawer.classList.contains('drawer--is-open');

    var observer = new MutationObserver(function() {
      var isOpenNow = cartDrawer.classList.contains('drawer--is-open');
      if (cartDrawerWasOpen && !isOpenNow && returnToWishlistAfterCartClose) {
        returnToWishlistAfterCartClose = false;
        window.setTimeout(function() {
          document.dispatchEvent(new CustomEvent('wishlist:open'));
        }, 80);
      }
      cartDrawerWasOpen = isOpenNow;
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  function observeWishlistDrawerForCartReturn() {
    var wishlistDrawer = document.getElementById('WishlistDrawer');
    if (!wishlistDrawer || !window.MutationObserver) return;

    wishlistDrawerWasOpen = wishlistDrawer.classList.contains('drawer--is-open');

    var observer = new MutationObserver(function() {
      var isOpenNow = wishlistDrawer.classList.contains('drawer--is-open');
      if (wishlistDrawerWasOpen && !isOpenNow && reopenCartAfterWishlistClose) {
        reopenCartAfterWishlistClose = false;
        window.setTimeout(function() {
          openCartDrawer();
        }, 80);
      }
      wishlistDrawerWasOpen = isOpenNow;
    });

    observer.observe(wishlistDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  function observeNewButtons() {
    if (!window.MutationObserver) return;

    var pending = false;
    var observer = new MutationObserver(function(mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-td-wishlist-toggle]')) || (node.querySelector && node.querySelector('[data-td-wishlist-toggle]'))) {
            pending = true;
            requestAnimationFrame(function() {
              pending = false;
              refreshButtons();
            });
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    refreshButtons();
    bindI18nRefresh();
    bindButtons();
    bindOpenConflictHandling();
    observeNewButtons();
    observeCartDrawerForReturn();
    observeWishlistDrawerForCartReturn();

    drawerController = new DrawerController();
    queuePruneIfNeeded();

    document.addEventListener('td:wishlist:updated', refreshButtons);
    window.addEventListener('storage', function(evt) {
      if (evt.key === STORAGE_KEY) {
        refreshButtons();
        renderDrawer();
      }
    });

    document.addEventListener('variant:change', function(evt) {
      var detail = evt && evt.detail ? evt.detail : {};
      updateDatasetForProductButtons(detail.variant || null);
      refreshButtons();
      requestAnimationFrame(function() {
        refreshButtons();
        requestAnimationFrame(refreshButtons);
      });
    });

    document.addEventListener('change', function(evt) {
      var target = evt && evt.target ? evt.target : null;
      if (!target || !target.matches) return;
      if (!target.matches('form[action*="/cart/add"] [name="id"], input[type="radio"][data-variant-input], input[type="radio"][data-index^="option"]')) return;
      window.setTimeout(function() {
        updateDatasetForProductButtons(null);
        refreshButtons();
      }, 40);
      window.setTimeout(function() {
        updateDatasetForProductButtons(null);
        refreshButtons();
      }, 160);
    }, true);

    updateDatasetForProductButtons(null);
    if (!window.TDWishlist) window.TDWishlist = {};
    window.TDWishlist.refreshButtons = refreshButtons;
    window.TDWishlist.renderDrawer = renderDrawer;
    emitUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
